import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { getJanelasColumns } from './tanStackColumns';

const JanelasTable = ({
  data,
  loading,
  totalRegistros,
  paginationState,
  onPaginationChange,
  podeEditar,
  onEditar,
  onHistorico,
  onExcluir,
  loadingAcao
}) => {
  const columns = useMemo(
    () => getJanelasColumns({ podeEditar, onEditar, onHistorico, onExcluir, loadingAcao }),
    [podeEditar, onEditar, onHistorico, onExcluir, loadingAcao]
  );

  return (
    <Row>
      <Col md={12}>
        <TanStackTable
          columns={columns}
          data={data}
          isSortable={false}
          withPagination
          manualPagination
          totalItems={totalRegistros}
          onPaginationChange={onPaginationChange}
          controlledPagination={paginationState}
          pageSizeOptions={[10, 25, 50, 100]}
          enableColumnConfig
          columnConfigKey="descarga-janelas-columns-v1"
          enableRowColors={false}
          loading={!!loading}
          className="mt-3"
        />
      </Col>
    </Row>
  );
};

export default JanelasTable;
